module.exports = __webpack_public_path__ + "static/media/md-calendar.00ef4085.svg";